import { uuid } from "uuidv4";
import { ListColumn, SelectedSort } from "./list-header";
import { PageData } from "./paged-request";
import { AUTOCOMPLETE_SUGGESTION_RENDER } from "./type-models";

export type FILTER_BAR_TYPE = 'text'|'date'|'dateplus'|'checkboxes'|'radios'|'dealer'|'numeric'|'autocomplete'|'readonly'|'dropdown'|'toggle';

export interface IFilterBar {

    paginationInfo  : PageData;
    filters         : FilterGroup[];
    requiredFilters : AppliedFilterBarOpt[];
    appliedFilters  : AppliedFilterBarOpt[];
    columns         : ListColumn[];
    selectedSort    : SelectedSort;
    baseUrl         : string;
    
}

export class FilterBarInputOpt {

    public uuid : string = '';
    public label : string = '';
    public data : any;
    public qsValue : any;

    /**
     * Constructor for a Filter Group Input object
     * @param label The name that appears in the input element
     * @param data The initial data state for this element
     * @param qsValue The value of this field that should be sent in the qs.  Optional, only used for checkbox/radio
     */
    public constructor(label : string, data : any, qsValue? : any) {
        this.label = label;
        this.data = data;
        this.uuid = uuid();

        if (qsValue || qsValue === 0) {
            this.qsValue = qsValue;
        }        
    }

}

export class AppliedFilterBarOpt {
    public uuid : string = '';
    public label : string = '';
    public qsName : string = '';
    public qsValue : string = '';
}

export class FilterGroup {

    public name : string = '';
    public type : FILTER_BAR_TYPE = 'text';
    public opts : FilterBarInputOpt[] = [];
    public uuid : string = '';
    public qsParamName : string = '';

    // Only used for autocomplete types
    public autoCompleteEndpoint : string = '';
    public autoCompleteRender: AUTOCOMPLETE_SUGGESTION_RENDER;

    /**
     * Constructor for a Filter Group object
     * @param name The name that appears in the filter bar
     * @param type What sort of input this group is
     * @param qsName The name for the group that will be used in the search URL
     */
    public constructor(name : string, type: FILTER_BAR_TYPE, qsName : string) {
        this.name = name;
        this.type = type;
        this.qsParamName = qsName;
        this.uuid = uuid();
    }

    /**
     * Builds a label for the filter bar.  Will put the number of selected options
     * for checkbox types in parenthesis
     */
    public getGroupLabel() {

        switch (this.type) {
            case 'checkboxes':
                const a = this.opts.reduce((acc : number, itm: FilterBarInputOpt) => {
                    if (itm.data === true) {
                        acc += 1;
                    } 
                    return acc;
                }, 0);

                return `${ this.name } (${a})`;
            default:
                return this.name;
        }
    }

}
